<template>
  <transition name="fade">
    <div
      class="fixed top-14 right-2 r flex items-center justify-center px-4 py-6 pointer-events-none z-[500]"
    >
      <div
        class="relative max-w-sm w-full bg-red-500 text-white p-5 rounded-lg shadow-lg text-sm flex items-center"
      >
        <button @click="closeAlert" class="absolute top-1 right-2">
          <font-awesome-icon icon="fa-xmark" class="text-white" />
        </button>
        <span>{{ error }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    error: {
      type: String,
      required: true,
    },
  },
  setup(_, { emit }) {
    const closeAlert = () => {
      emit("close-alert");
    };

    return { closeAlert };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
